export default class PreviewVideoModel {
  constructor({
    id = null,
    src = null,
    file = null,
    order = null,
    destroy = false,
  }) {
    this.id = id;
    this.jsClass = "PreviewVideoModel";
    this.src = src;
    this.file = file;
    this.order = order;
    this.destroy = destroy;
  }

  json = () => {
    return {
      id: this.id,
      jsClass: this.jsClass,
      src: this.src,
      order: this.order,
      destroy: this.destroy,
    };
  };

  updateValues({ id = null, file = null, src = null, order = null }) {
    this.id = id;
    this.src = src;
    this.file = file;
    this.order = order;
  }
}
